import { useCallback, useState } from "react";
import { dbStore, offlineDb } from "@/db/offlineDb";
import { uuid } from "@/lib/uuid";

export function useKotActions(tables, serverOnline, queueAction) {
  const [offlineKotWarning, setOfflineKotWarning] = useState(false);
  const sendKot = useCallback((table, cart, captain) => {
    const orderId = uuid();
    const kotId = uuid();
    const now = new Date().toISOString();
    const order = { id: orderId, order_id: orderId, table, captain, status: "kot_sent", items: cart, created_at: now, updated_at: now };
    const ticket = { id: kotId, kot_id: kotId, order_id: orderId, table, type: "Dine-in", captain, minutes: 0, items: cart.map(item => ({ qty: item.qty, name: item.name, modifier: item.variant || item.modifier || "Standard" })) };
    offlineDb.transaction("rw", [dbStore("orders"), dbStore("tickets"), dbStore("tables")], async () => {
      await dbStore("orders").put(order);
      await dbStore("tickets").put(ticket);
      const target = tables.find(item => item.name === table);
      if (target) await dbStore("tables").put({ ...target, status: "occupied" });
    }).then(() => queueAction("PUNCH_KOT", orderId, { order, ticket }));
    if (!serverOnline) setOfflineKotWarning(true);
    return ticket;
  }, [queueAction, serverOnline, tables]);

  return { sendKot, offlineKotWarning, dismissOfflineKotWarning: useCallback(() => setOfflineKotWarning(false), []) };
}